import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { RouteShareService } from './route-share.service';
import { LoginService } from '@shared-angular/services/login.service';


@Injectable({
  providedIn: 'root'
})
export class DocSearchWebsiteService {



  constructor(private http: HttpClient, private rss: RouteShareService, private loginService: LoginService) { }


  public async getLinksForUrl(url: string): Promise<string[]> {
    const result = await firstValueFrom(this.http.post<{ links: string[] }>(
      `/api/toolbox/bot/admin/botwebsite/getlinks`,
      { url, projectId: this.rss.projectService.selectedProject?._id ?? '-' })
    );
    return result.links;
  }

  public async createPdfFromUrls(urls: string[]) {
    if (this.rss.projectService.selectedProject) {
      return await firstValueFrom(
        this.http.post(
          `/api/toolbox/bot/admin/botwebsite/createpdf`,
          {
            projectId: this.rss.projectService.selectedProject._id,
            urls
          }
        )
      );
    } else {
      throw new Error('No project selected');
    }
  }

  public async replacePdfFromUrls(urls: string[], docid: string) {
    if (this.rss.projectService.selectedProject) {
      return await firstValueFrom(
        this.http.post(
          `/api/toolbox/bot/admin/botwebsite/replace`,
          {
            urls,
            docid
          }
        )
      );
    } else {
      throw new Error('No project selected');
    }
  }
}
